var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1880,
    height: 1375,
    viewBox: "0 0 1880 1375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.226 1077.93H532.354C742.968 1077.93 852.853 997.81 852.853 859.308C852.853 758.58 795.62 689.901 706.338 661.287C771.581 626.947 812.791 565.137 812.791 485.012C812.791 360.247 709.771 276.687 509.459 276.687H328.226V416.333H486.567C576.994 416.333 626.214 447.238 626.214 510.195C626.214 573.15 576.994 605.199 486.567 605.199H328.226V740.265H518.617C614.767 740.265 666.276 772.317 666.276 839.849C666.276 908.528 614.767 938.289 518.617 938.289H328.226V1077.93Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.52 446.174L1486.06 310.709L890.011 906.754L1025.48 1042.22L1621.52 446.174Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.38 311.63L888.913 447.095L1484.96 1043.14L1620.42 907.675L1024.38 311.63Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.576 191.576H0V1251.63H191.576V191.576Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1182.66L0 1374.24L1880 1374.24V1182.66H0Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.15527e-05L0 191.576L1880 191.576V9.15527e-05L0 9.15527e-05Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1880 191.576H1688.42V1251.63H1880V191.576Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLogo);
export default __webpack_public_path__ + "static/media/BX-LOGO.c9bd52a89a160184c96af30cb3ca68fc.svg";
export { ForwardRef as ReactComponent };